import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'


//车区列表
export function parkingList(data) {
    return fetch({
        url: config.WEB_PARKING_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
//价格列表
export function pricingList(data) {
       return fetch({
           url: config.WEB_PARKINGPRICONGLIST_API,
           method: 'POST',
           data: qs.stringify(data)
       })
   }
   //常用时间列表
   export function commonlyPricingList(data) {
       return fetch({
           url: config.WEB_COMMONLYPRICELIST_API,
           method: 'POST',
           data: qs.stringify(data)
       })
   }
 //省份列表
  export function provinceList(data) {
       return fetch({
           url: config.WEB_PROVINCE_API,
           method: 'POST',
           data: qs.stringify(data)
       })
   }
